import { useState, useEffect } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { getTimeIntervals } from "../../../ApiService/ApiService";
import TimeIntervalTable from "./TimeIntervalTable";
import AddTimeInterval from "./AddTimeInterval";
import { Add } from "@mui/icons-material";

function TimeIntervalSection() {
  const [intervals, setIntervals] = useState({});
  const [showAddTimeInterval, setShowAddTimeInterval] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchIntervals();
  }, []);

  const fetchIntervals = async () => {
    try {
      setLoading(true);
      const response = await getTimeIntervals();
      setIntervals(response?.data);
    } catch (err) {
      console.error("Error fetching time intervals:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderMainContent = () => {
    if (showAddTimeInterval) {
      return (
        <AddTimeInterval
          fetchIntervals={fetchIntervals}
          setShowAddTimeInterval={setShowAddTimeInterval}
        />
      );
    } else {
      return (
        <TimeIntervalTable
          intervals={intervals}
          fetchIntervals={fetchIntervals}
        />
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          display: showAddTimeInterval ? "none" : "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          paragraph
          sx={{ color: "black", fontWeight: 600, fontSize: 22 }}
          xs={4}
          sm={4}
          md={6}
          lg={8}
          xl={8}
        >
          Time Intervals
        </Typography>
        <Button
          xs={8}
          sm={8}
          md={6}
          lg={4}
          xl={4}
          onClick={() => setShowAddTimeInterval(true)}
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mb: 2,
            textTransform: "unset",
            borderRadius: 2,
          }}
        >
          <Add fontSize="small" />
          Add Time Interval
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{renderMainContent()}</>
      )}
    </>
  );
}

export default TimeIntervalSection;
